/** Integrations → Webhooks: signed deliveries, the Signing column and its dialogs (PREC-4249). */
export const enWebhookSigning = {
	column: "Signing",
	state: {
		signed: "Signed",
		notViewed: "Secret not yet viewed",
	},
	secretCreated: "Secret created {{date}}",
	rotatingUntil: "Rotating: old secret valid until {{date}}",
	createdBeforeSigning: "Created when signing was introduced",
	createNote: "Every delivery is signed. After you save, you will see the signing secret once.",
	menu: {
		open: "More actions",
		sendTestEvent: "Send test event",
		rotateSecret: "Rotate secret",
		revealSecret: "Reveal secret",
		once: "once",
	},
	secret: {
		createdTitle: "Webhook created: copy your signing secret",
		createdLead:
			"You won't see this secret again. Copy it now and store it where your receiver can read it. If you lose it, rotate it from the webhook's menu.",
		rotatedTitle: 'New signing secret for "{{name}}"',
		rotatedLead: "You won't see this secret again. Copy it now.",
		rotatedOverlap:
			"The previous secret stays valid until {{date}}. Until then each delivery is signed with both: X-Signalist-Signature: t=…,v1=<new>,v1=<old>. Accept a request if either value matches.",
		revealedTitle: 'Signing secret for "{{name}}"',
		revealedLead:
			'This secret was created for you when signing was introduced. This is the only time it can be shown. Afterwards the only way to get a new one is "Rotate secret".',
		// A webhook from before signing is delivered as before release #8 (unsigned, redirects
		// followed) until this reveal switches it over: webhookDeliveryMode (API), PREC-4805.
		revealedNote:
			"From now on every delivery to this webhook is signed with it, goes only to a public address and follows no redirect. If your webhook URL redirects, replace it with the address it redirects to. A receiver that does not check the signature keeps accepting deliveries.",
		label: "Signing secret",
		newLabel: "New signing secret",
		copy: "Copy",
		copied: "Copied",
		done: "I have copied the secret",
	},
	headers: {
		title: "Every delivery carries",
		formula: 'v1 = hex HMAC-SHA256 of "<t>.<raw body>" with the secret, t = unix seconds.',
	},
	guidance: {
		title: "In your receiver",
		shortTitle: "Verify every delivery",
		hmac: "Compute the HMAC over the raw request body and compare it with a constant-time function.",
		replay: "Reject a request whose t is more than 5 minutes off your clock (replay protection).",
		dedupe: "Dedupe on X-Signalist-Delivery-Id: a retry carries the same id.",
		rotation: "During a rotation two v1= values are sent; accept the request if either matches.",
		shortHmac: "Compare the signature with a constant-time function.",
		shortReplay: "Reject a t more than 5 minutes off.",
		shortDedupe: "Dedupe on X-Signalist-Delivery-Id.",
		link: "Read the full guide in the help center",
		shortLink: "Full guide with code samples",
	},
	rotate: {
		title: "Rotate signing secret",
		// A rotation also switches a webhook from before signing over (PREC-4805): the last sentence.
		body: "A new secret is generated and shown once. The current secret keeps working for 24 hours: during that time every delivery carries two signatures (v1=<new>,v1=<old>), so your receiver can switch without dropping deliveries. After 24 hours only the new secret is valid. After rotating, every delivery to this webhook is signed, goes only to a public address and follows no redirect.",
		again: "Rotating again within the 24 hours replaces the previous secret straight away.",
		confirm: "Rotate",
		failed: "The secret could not be rotated. Please try again.",
	},
	reveal: {
		failed: "The secret could not be shown. Please try again.",
	},
	test: {
		title: 'Send test event to "{{name}}"',
		lead: "Delivers a signed sample lead to {{url}}. No real lead is sent and nothing is written to your lists.",
		sending: "Sending…",
		delivered: "Delivered.",
		deliveredDetail: "Your receiver answered {{outcome}} in {{ms}} ms.",
		notDelivered: "Not delivered.",
		notDeliveredAnswer:
			"Your receiver answered {{outcome}} after {{ms}} ms. If it checks the signature, make sure it uses the current secret and the raw request body.",
		notDeliveredNoAnswer: "{{outcome}} after {{ms}} ms.",
		whatWasSent: "What was sent",
		receiversAnswer: "Receiver's answer",
		note: 'Test events are marked "event":"test" and do not appear in the delivery status of the table.',
		sendAgain: "Send again",
		close: "Close",
		failed: "The test event could not be sent. Please try again.",
	},
	section: {
		title: "Signing",
	},
};
